import { AND, GE, LE, UID, VAR } from 'shared/api/query/constants';
import { isEmptyRange } from '@/lib/filter/number';
import { notHasFilter } from 'shared/api/query/filter';
import { property, propertyValue } from 'shared/api/query/configs.json';
import { reverseEdge } from 'shared/api/query/edges';

export const makeNumberFn = (childrenFn, varIdFn) => (scope, index) => {
  const varName = varIdFn(index);

  if (scope.isEmpty === true) {
    const varBlocks = [
      {
        alias: VAR,
        uid: [scope.property.uid],
        model: property.model,
        func: { name: UID },
        children: [
          {
            attr: reverseEdge(propertyValue.edges.property),
            model: propertyValue.model,
            filter: notHasFilter(propertyValue.edges.number),
            children: childrenFn(varName),
          },
        ],
      },
    ];
    const filterTree = {
      func: {
        name: UID,
        needsVar: [{ name: varName, typ: 1 }],
      },
    };
    return { filterTrees: [filterTree], varBlocks };
  }

  if (isEmptyRange(scope.numberRange)) {
    return { filterTrees: [], varBlocks: [] };
  }

  const filters = [];
  if (scope.numberRange.min !== undefined && scope.numberRange.min !== null) {
    let funcName = scope.numberRange.minType;
    if (funcName === undefined || funcName === '') {
      funcName = GE;
    }
    filters.push({
      func: {
        name: funcName,
        attr: propertyValue.edges.number,
        args: [{ value: `${scope.numberRange.min}` }],
      },
    });
  }

  if (scope.numberRange.max !== undefined && scope.numberRange.max !== null) {
    let funcName = scope.numberRange.maxType;
    if (funcName === undefined || funcName === '') {
      funcName = LE;
    }
    filters.push({
      func: {
        name: funcName,
        attr: propertyValue.edges.number,
        args: [{ value: `${scope.numberRange.max}` }],
      },
    });
  }

  const varBlocks = [
    {
      alias: VAR,
      func: { name: UID },
      uid: [scope.property.uid],
      model: property.model,
      children: [
        {
          attr: reverseEdge(propertyValue.edges.property),
          model: propertyValue.model,
          filter: {
            op: AND,
            child: filters,
          },
          children: childrenFn(varName),
        },
      ],
    },
  ];

  const filterTree = {
    func: {
      name: UID,
      needsVar: [{ name: varName, typ: 1 }],
    },
  };
  return { filterTrees: [filterTree], varBlocks };
};

export const directPropNumberFn = (scope) => {
  if (scope.isEmpty === true) {
    return {
      filterTrees: [notHasFilter(scope.directProperty.edgeName)],
      varBlocks: [],
    };
  }

  if (isEmptyRange(scope.numberRange)) {
    return { filterTrees: [], varBlocks: [] };
  }

  const filters = [];
  if (scope.numberRange.min !== undefined && scope.numberRange.min !== null) {
    let funcName = scope.numberRange.minType;
    if (funcName === undefined || funcName === '') {
      funcName = GE;
    }
    filters.push({
      func: {
        name: funcName,
        attr: scope.directProperty.edgeName,
        args: [{ value: `${scope.numberRange.min}` }],
      },
    });
  }

  if (scope.numberRange.max !== undefined && scope.numberRange.max !== null) {
    let funcName = scope.numberRange.maxType;
    if (funcName === undefined || funcName === '') {
      funcName = LE;
    }
    filters.push({
      func: {
        name: funcName,
        attr: scope.directProperty.edgeName,
        args: [{ value: `${scope.numberRange.max}` }],
      },
    });
  }

  return {
    filterTrees: filters,
    varBlocks: [],
  };
};
